import { createSlice } from "@reduxjs/toolkit";

export const countrySlice = createSlice({
  name: "country",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    countryslist: [],
    model: false,
    error_msg: null,
    rowdata: {},
    countryParams: {
      no_of_pages: 0,
      listCount: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getCountrys: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    countryListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.countryParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        countryslist: action.payload.response.results,
        loading: false,
        countryParams: {
          ...state.countryParams,
          no_of_pages: noofpages,
        },
      };
    },
    countryAdd: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    countryAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    countryEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },
    countryEditSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },
    countryDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetCountryParams: (state, action) => {
      return {
        ...state,
        countryParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getCountrys,
  countryListSuccessful,
  countryAdd,
  countryAddSuccessful,
  countryEdit,
  countryEditSuccessful,
  countryDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetCountryParams
} = countrySlice.actions;

export default countrySlice.reducer;
